export const DEFAULT_PERMISSION_GROUP_TO_DELETE = { name: '', permissionGroupId: '' };

export const PERMISSIONS_GROUP_MODALS = {
  createGroup: 'createGroup',
  deleteGroup: 'deleteGroup',
  changeGroup: 'changeGroup',
};
